export function fileToResizedDataURL(file, { max = 512, square = false, type = "image/jpeg", quality = 0.85 } = {}) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();
    reader.onload = () => { img.src = reader.result; };
    reader.onerror = reject;
    img.onload = () => {
      const { width, height } = img;
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      if (square) {
        const s = Math.min(width, height);
        canvas.width = max; canvas.height = max;
        ctx.drawImage(img, (width - s) / 2, (height - s) / 2, s, s, 0, 0, max, max);
      } else {
        const scale = Math.min(1, max / Math.max(width, height));
        canvas.width = Math.round(width * scale);
        canvas.height = Math.round(height * scale);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      }
      resolve(canvas.toDataURL(type, quality));
    };
    img.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export function fmtEventDate(s) {
  if (!s) return "Date to be announced";
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  return d.toLocaleString("en-IN", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function isPastEvent(s) {
  if (!s) return false;
  const d = new Date(s);
  return !isNaN(d.getTime()) && d.getTime() < Date.now();
}
